var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSourcesImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1996 7.74276L19.5847 9.81443L10.8146 13.9578L2.04443 9.81443L6.42951 7.74276M15.1996 12.3465L19.5847 14.4181L10.8146 18.5615L2.04443 14.4181L6.42951 12.3465M10.8146 1.06738L19.5847 5.21072L10.8146 9.35406L2.04443 5.21072L10.8146 1.06738Z",
    stroke: "black",
    strokeWidth: 1.46154
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSourcesImg);
export default __webpack_public_path__ + "static/media/sourcesImg.77de17e8c7e9d9a89bea47c5c1f08a91.svg";
export { ForwardRef as ReactComponent };